import React from 'react';
import { Link } from 'react-router-dom';
import { HeaderNavLinkProps } from '../interfaces';
import './HeaderNavLink.scss';

const HeaderNavLink: React.FC<HeaderNavLinkProps> = ({ to, isActive, children }) => (
  <Link to={to} className={`header-nav__link ${isActive ? 'is-active' : ''}`}>
    {children}
  </Link>
);

export default HeaderNavLink;
